import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Target, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ZRoofing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-644" data-mp="a3d2l32sfoq8">
      <div className="max-w-6xl mx-auto px-4" data-id="element-645" data-mp="a1jynvjk7ilx">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-646" data-mp="3sgkq6qx5kcmx">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-647" data-mp="3ijy644cnhply" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-648" data-mp="3njb0da5upyyk">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-649" data-mp="3nfwzy7gqzztr">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-650" data-mp="39jjlz8bfagk1">
              Local Service
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-651" data-mp="14qdu3rgwu3wf">
              Brand Authority
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-652" data-mp="1ep39ndlc3c9i">
              Ads
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-653" data-mp="m0pfxa1a323r">
            Z Roofing and Waterproofing
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-654" data-mp="vra9gj23hgft">
            From Invisible to Trusted: Building a Local Authority Brand
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-655" data-mp="3ag4ranijzzx">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-656" data-mp="39ep0svjypbv">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-657" data-mp="3ui2bxd9fyklj">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-658" data-mp="23d8vibod4kvb">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-659" data-mp="2847e5hwtpv1q" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-660" data-mp="2c5j5brvcioc1">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-661" data-mp="2c7nb6fct1xey">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-662" data-mp="1kdux9hjlonz0" />
                </div>
                <div data-id="element-663" data-mp="1ofghjnygs4j8">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-664" data-mp="1oewwvzhfj21i">
                    200%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-665" data-mp="2zv54wgfmr5kk">
                    Lead Increase
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-666" data-mp="3exvedfz6rf7v">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-667" data-mp="3a14zgvz4apo1">
                <Target className="w-24 h-24 text-engage-yellow" data-id="element-668" data-mp="355z7bff4geri" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-669" data-mp="314nmdn770hpn">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-670" data-mp="2w8ykhd7paoq6">
                  <Target className="w-6 h-6 text-engage-yellow" data-id="element-671" data-mp="2m9hd8rcsw2s3" />
                </div>
                <div data-id="element-672" data-mp="2mban0fipn34b">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-673" data-mp="2i8e1afxviqw5">
                    #1
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-674" data-mp="khbdnzp5evu9">
                    Local Market Share
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-675" data-mp="nhwg6fwtomyc">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-676" data-mp="eihojd4x66c9">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-677" data-mp="iitbiwkr8iqw" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-678" data-mp="4rmzy247aunn">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-679" data-mp="9kpxelc3mo94">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-680" data-mp="3qylan3j4s67n" />
                </div>
                <div data-id="element-681" data-mp="3vxg5j3udhl84">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-682" data-mp="3hzrmm1jv8o5p">
                    5x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-683" data-mp="3myb6zxit9rvy">
                    ROI on Ad Spend
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-684" data-mp="3cesbewo78tsv">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-685" data-mp="38cdtqfw9o036">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-686" data-mp="3mbn9jegk8s6m">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-687" data-mp="3hdlnqlrr2erg" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-688" data-mp="3w1gjkb120z8r">
              Z Roofing operated in a highly competitive local market where
              trust determines who wins the job. Despite delivering quality
              work, their online presence lacked consistency and
              professionalism, making it difficult to stand out. The gap between
              real-world results and digital perception limited their ability to
              convert potential customers.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-689" data-mp="32mm6x7qvwdv7">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-690" data-mp="36p0to2xobxrr">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-691" data-mp="3bjenw20lnyuu" />
              <div className="relative z-10" data-id="element-692" data-mp="3leor2t2qica7">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-693" data-mp="3lhkqymy57b1a">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-694" data-mp="3ugoatt54vugu" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-695" data-mp="1w0jr5t10yqit">
                  We built a content system focused on consistency, visual
                  proof, and brand elevation. By showcasing real projects,
                  refining presentations, and maintaining a steady publishing
                  rhythm, we transformed their social presence into a
                  trust-building asset. Every piece of content was designed to
                  reinforce credibility and support the sales process.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-696" data-mp="1epeiilep4vny">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-697" data-mp="26hvp59f8yf81" />
              <div className="relative z-10" data-id="element-698" data-mp="22ez1336xtqwp">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-699" data-mp="1xi8legz1oxbt">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-700" data-mp="r2es20wyb1zr" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-701" data-mp="m2af2kv94pea">
                  The brand evolved into a more polished and trustworthy
                  presence, aligning its online image with the quality of its
                  work. With consistent, high-quality content, Z Roofing now
                  operates with a digital presence that builds confidence before
                  the first interaction{'\u2014'}supporting stronger conversions
                  and long-term growth.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-702" data-mp="39t2soaqakgiz">
            <div className="flex justify-center mb-8" data-id="element-703" data-mp="304kum19ecnj1">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-704" data-mp="3039npsknmznp">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-705" data-mp="1h5d4rj3dv0iq" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-706" data-mp="y8vgxcrnnkrr">
              We didn{'\u2019'}t change the work{'\u2014'}we changed how people
              see it. And that changed everything.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-707" data-mp="2im2tzmxetobb">
              <img src="https://cdn.magicpatterns.com/uploads/3Ab7qTKH2BWMBWASWsKWtB/Z_Roofing_and_Waterproofing-CS.png" alt="Z Roofing and Waterproofing" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-708" data-mp="2dnsw34kaw9m0" />
              <div className="font-bold text-engage-white text-lg" data-id="element-709" data-mp="1bte3h4akn6qn">
                Z Roofing Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-710" data-mp="17r9dqgn8uu9a">
                Owner, Z Roofing and Waterproofing
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-711" data-mp="xstlgachdey7">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-712" data-mp="otq1z59eixj6" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-713" data-mp="2n81eloyzjf8o">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-714" data-mp="2j7hi8nm8kfnl">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-715" data-mp="4yx34o3r9vbc">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-716" data-mp="eqkt0kknz4ap">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}